/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-16 18:08:42
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-09 17:37:09
 * @FilePath: /unifyxp-v2-store-portal/src/components/Slider/MarginSlider.tsx
 */
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { EnumPosition } from 'src/types/common/common';
import css from './css.module.less'; //
import Slider from './index';

const IconTop = (
  <Icon
    type='icontop1'
    className={css.icon}
    onClick={(e) => e.stopPropagation()}
  />
);

const IconLeft = (
  <Icon
    type='iconleft1'
    className={css.icon}
    onClick={(e) => e.stopPropagation()}
  />
);

const IconRight = (
  <Icon
    type='iconright1'
    className={css.icon}
    onClick={(e) => e.stopPropagation()}
  />
);
const IconBottom = (
  <Icon
    type='iconbottom'
    className={css.icon}
    onClick={(e) => e.stopPropagation()}
  />
);

const Title = (props) => {
  const { title, position, customIcon } = props;
  const icon =
    customIcon ||
    {
      [EnumPosition.top]: IconTop,
      [EnumPosition.bottom]: IconBottom,
      [EnumPosition.left]: IconLeft,
      [EnumPosition.right]: IconRight,
    }[position] ||
    null;
  return (
    <div className={css.titleContainer}>
      {icon}
      {title}
    </div>
  );
};

const MarginNumberSlider = (props) => {
  const {
    position,
    title,
    value,
    onChange,
    max = 800,
    min = -800,
    suffix,
    customIcon,
    disabled,
  } = props;
  return (
    <ItemWrapper
      size={'small'}
      title={
        <Title title={title} position={position} customIcon={customIcon} />
      }>
      <Slider
        value={value}
        onChange={onChange}
        max={max}
        min={min}
        suffix={suffix}
        disabled={disabled}
      />
    </ItemWrapper>
  );
};

export default MarginNumberSlider;
